import { Fragment } from "react";

import {
  IgCoreBackgroundColors,
  IgCoreTextColors,
} from "@intelligems/ig-design-tokens/constants";
import { Box, SxProps } from "@mui/material";
import { IgDialog } from "@intelligems/ig-theme/IgDialog";

import { Z_INDEX_LEVELS } from "../constants";

import { splitGrabbedContent } from "./splitGrabbedContent";

const DIALOG_TOKENS: Record<string, SxProps> = {
  content: {
    background: IgCoreBackgroundColors.baseLightMid,
    borderRadius: 1,
    color: IgCoreTextColors.primary,
    fontFamily: "monospace",
    fontSize: 12,
    lineHeight: 1.6,
    margin: 0,
    maxHeight: "60vh",
    overflow: "auto",
    padding: 2,
    whiteSpace: "pre-wrap",
    wordBreak: "break-word",
  },
  highlight: {
    background: IgCoreBackgroundColors.accent,
    borderRadius: 0.5,
    color: IgCoreTextColors.accent,
    fontWeight: 600,
    padding: "0 3px",
  },
};

type GrabbedContentDialogProps = {
  content: string;
  onClose: () => void;
};

export const GrabbedContentDialog = ({
  content,
  onClose,
}: GrabbedContentDialogProps) => (
  <IgDialog
    content={
      <Box component="pre" sx={DIALOG_TOKENS.content}>
        {splitGrabbedContent(content).map((segment, index) =>
          segment.kind === "text" ? (
            <Fragment key={index}>{segment.text}</Fragment>
          ) : (
            <Box component="mark" key={index} sx={DIALOG_TOKENS.highlight}>
              {segment.text}
            </Box>
          )
        )}
      </Box>
    }
    handleClose={onClose}
    hideActions
    maxWidth="md"
    showCloseIcon
    showDialog
    sx={{ zIndex: Z_INDEX_LEVELS.dialog }}
    title="Copied to clipboard"
  />
);
